// author @sanjid -> sanjid@filerskeepers.co
// version 1.0.0
// delegate.js

const delegate = ({target = document, selector, event, handler}) => {
	target.addEventListener(event, event => {
		const targetElement = event.target.closest(selector);
		if (targetElement !== null && targetElement !== undefined && handler !== undefined && handler) {
			handler(targetElement, event);
		}
	});
}

export default delegate;